import { Breadcrumbs as e, variants as m } from "./breadcrumbs.js";
export {
  e as Breadcrumbs,
  m as variants
};
